import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmsSubmittalContainerComponent } from './vms-submittal-container/vms-submittal-container.component';

const routes: Routes = [
  {
    path: '',
    component: VmsSubmittalContainerComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VmsSubmittalRoutingModule { }
